import type { CountryCode } from '@capsico/contracts';

/**
 * Money for the customer app, keyed by the order's country: India "₹130", Nepal "Rs 130".
 * Minor units in, whole units out (paise / paisa only shown when not zero). Never hard-code a symbol.
 */
export function money(country: CountryCode | null | undefined, minor: number): string {
  const value = minor / 100;
  const whole = Number.isInteger(value);
  const text = value.toLocaleString(country === 'NP' ? 'en-NP' : 'en-IN', {
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return country === 'NP' ? `Rs ${text}` : `₹${text}`;
}

/** "₹300 for two" style figure, or null when the outlet has not set one. */
export function costForTwo(
  country: CountryCode | null | undefined,
  minor: number | null,
): string | null {
  return minor === null ? null : money(country, minor);
}
